const productTitle = document.querySelector('.product-title h1')?.textContent?.trim().toLowerCase().replace(/\s+/g, '');
if (productTitle === "tshirt") {
  document.getElementById("Size-Pop")?.classList.add("hidden");
}


const oImageMeasure = [
  {
    id: "slimfittrousers",
    titulo: "LEG OPENING",
    desc: "Measure across the bottom hem of the leg from one side to the other.",
    cdn: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/leg_opening_pants.png?v=1742973372",
    css: "img-size-measure-slimfittrousers"
  },
  {
    id: "slimfittrousers",
    titulo: "FRONT RISE",
    desc: "Measure from the crotch seam up to th top of the waistband.",
    cdn: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/front_rise_pants.png?v=1742973371",
    css: "img-size-measure-slimfittrousers"
  },
  {
    id: "slimfittrousers",
    titulo: "INSEAM LENGTH",
    desc: "Start at the crotch seam and measure down to the hem of the leg.",
    cdn: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/inseam_pants.png?v=1742973371",
    css: "img-size-measure-slimfittrousers"
  },
  {
    id: "slimfittrousers",
    titulo: "WAIST WIDTH",
    desc: "Measure straight across the waistband from edge to edge.",
    cdn: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/waist_pants.png?v=1742973371",
    css: "img-size-measure-slimfittrousers"
  },
  {
    id: "388hoodie",
    titulo: "CHEST WIDTH",
    desc: "Measure from the top of one shoulder seam to the other, following the natural curve of the garment.",
    cdn: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/chest.png?v=1742839677",
    css: "img-size-measure-hoodie"
  },
  {
    id: "388hoodie",
    titulo: "BODY LENGTH",
    desc: "Start at the highest point of the shoulder seam (next to the collar) and measure straight down to the hem.",
    cdn: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/body.png?v=1742839677",
    css: "img-size-measure-hoodie"
  },
  {
    id: "388hoodie",
    titulo: "SLEEVE LENGTH",
    desc: "Measure from the shoulder seam down to the end of the sleeve.",
    cdn: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/arm_length.png?v=1744444078",
    css: "img-size-measure-hoodie"
  },
  {
    id: "388crewneck",
    titulo: "SHOULDER WIDTH",
    desc: "Measure from the top of one shoulder seam to the other, following the natural curve of the garment.",
    cdn: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/shoulder_width__crewneck.png?v=1742973277",
    css: "img-size-measure-crewneck"
  },
  {
    id: "388crewneck",
    titulo: "CHEST WIDTH",
    desc: "Place the measuring tape one inch below the armpit and extend it across the chest to the opposite side.",
    cdn: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/chest_crewneck.png?v=1742973277",
    css: "img-size-measure-crewneck"
  },
  {
    id: "388crewneck",
    titulo: "BODY LENGTH",
    desc: "Start at the highest point of the shoulder seam (next to the collar) and measure straight down to the hem.",
    cdn: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/body_crewneck.png?v=1742973277",
    css: "img-size-measure-crewneck"
  },
  {
    id: "388crewneck",
    titulo: "SLEEVE LENGTH",
    desc: "Measure from the shoulder seam down to the end of the sleeve.",
    cdn: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/sleeve_length__crewneck.png?v=1742973276",
    css: "img-size-measure-crewneck"
  },
  {
    id: "overshirt",
    titulo: "SHOULDER WIDTH",
    desc: "Measure from the top of one shoulder seam to the other, following the natural curve of the garment.",
    cdn: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/shoulder_w_over_shirt.png?v=1742973322",
    css: "img-size-measure-over-shirt"
  },
  {
    id: "overshirt",
    titulo: "CHEST WIDTH",
    desc: "Place the measuring tape one inch below the armpit and extend it across the chest to the opposite side.",
    cdn: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/chest_over_shirt.png?v=1742973322",
    css: "img-size-measure-over-shirt"
  },
  {
    id: "overshirt",
    titulo: "BODY LENGTH",
    desc: "Start at the highest point of the shoulder seam (next to the collar) and measure straight down to the hem.",
    cdn: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/body_over_shirt.png?v=1742973322",
    css: "img-size-measure-over-shirt"
  },
  {
    id: "overshirt",
    titulo: "SLEEVE LENGTH",
    desc: "Measure from the shoulder seam down to the end of the sleeve.",
    cdn: "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/arm_length_over_shirt.png?v=1742973322",
    css: "img-size-measure-over-shirt"
  }
];

const oImageRelation = {
  "overshirt": {
    "cm": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/OVER_SHIRT_cm_comp.png?v=1742402094",
    "in": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/OVER_SHIRT_in_comp.png?v=1742402110"
  },
  "slimfittrousers": {
    "cm": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/comp_sizech_pant_width_cm.png?v=1743547408",
    "in": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/comp_sizech_pant_width.png?v=1743547418"
  },
  "388hoodie": {
    "cm": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/HOODIE_cm_comp.png?v=1742402094",
    "in": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/HOODIE_in_comp2.png?v=1742402110"
  },
  "388crewneck": {
    "cm": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/CREWNECK_cm_comp.png?v=1742402094",
    "in": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/CREWNECK_in_comp.png?v=1742402110"
  },
  "tshirt": {
    "cm": "ts cm",
    "in": "ts in"
  },
};

const oImageRelation_pants = {
  "slimfittrousers": {
    "cm": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/comp_sizech_pant_length_cm_6cd2e168-11fa-4282-801c-4fd92620e208.png?v=1743617621",
    "in": "https://cdn.shopify.com/s/files/1/0668/7388/4827/files/comp_sizech_pant_length_in.png?v=1743617647"
  },
};

function getParentSelector() {
  return document.querySelector('quick-add-modal[open]') ? 
    document.querySelector('quick-add-modal[open]'):
    document.querySelector('main');
}

function getProductName() {
  const $parentSelector = getParentSelector();
  return $parentSelector.querySelector('.product-title h1')?.textContent?.trim().replace(/\s+/g, '').toLowerCase();
}

// Función para actualizar la imagen según la medida activa
function updateSizeGuideImage() {
  const $parentSelector = getParentSelector();
  const productName = getProductName();

  if (oImageRelation[productName]) {
    const activeMeasure = document.querySelector("#measurements .measure.active").textContent.toLowerCase();
    const newImageName = oImageRelation[productName][activeMeasure];
    const miElemento = document.getElementById('trousers');
    const header_trouser_width = document.getElementById('header-trousers-width');
    const header_trouser_length = document.getElementById('header-trousers-length');

    // Actualizar la imagen solo si existe una relación para el producto
    if (newImageName) {
      const element = document.querySelector(".img-size");
      element.src = newImageName;
    }
            
    if (productName === "slimfittrousers"){
        const ImageTrouser = oImageRelation_pants[productName][activeMeasure];
        miElemento.classList.remove('hidden');
        header_trouser_width.classList.remove('hidden');
        header_trouser_length.classList.remove('hidden');
        document.querySelector(".img-size-trousers").src = ImageTrouser;
    }
    else{
        miElemento.classList.add('hidden');
        header_trouser_width.classList.add('hidden');
        header_trouser_length.classList.add('hidden');
    }
  }
}

function updateImageMeasure(){
    const $parentSelector = getParentSelector();
    const productName = getProductName();
    const contenedor = document.querySelector('.popup-carrousel-size-measure');
    const idSeleccionado = productName;
    const medidasFiltradas = oImageMeasure.filter(item => item.id === idSeleccionado);

    contenedor.innerHTML = "";
    medidasFiltradas.forEach(item => contenedor.appendChild(createMeasureElement(item)));
}

function createMeasureElement(item) {
  const div = document.createElement("div");
  div.innerHTML = `
    <img src="${item.cdn}" alt="Size Measure" class="${item.css}">
    <p class="header-img-size-measure header-size-measure"><span class="header-size-measure">${item.titulo}</span></p>
    <p class="desc-img-size-measure desc-size-measure"><span class="desc-size-measure">${item.desc}</span></p>
  `;
  return div;
}

// Función para abrir el popup y actualizar la imagen
function openSizeGuidePopup() {
  document.getElementById("sizeGuidePopup").classList.remove("hidden");
  updateSizeGuideImage(); // Actualizar la imagen al abrir el popup
  updateImageMeasure();
}

// Función para cerrar el popup
function closeSizeGuidePopup() {
  document.getElementById("sizeGuidePopup").classList.add("hidden");
}

// Event listeners para cambiar entre IN y CM
document.addEventListener("DOMContentLoaded", function () {
  const measurements = document.querySelectorAll("#measurements .measure");

  measurements.forEach((span) => {
    span.addEventListener("click", function () {
      // Remover la clase 'active' de todos los elementos
      measurements.forEach((el) => el.classList.remove("active"));
      // Agregar la clase 'active' al span clickeado
      this.classList.add("active");

      // Actualizar la imagen después de cambiar la medida activa
      updateSizeGuideImage();
    });
  });
});
